import React from 'react'
import { injectIntl, IntlShape } from 'react-intl'
import { Table, UppercaseL } from 'cimple-web-common'

type TableHeaderProps = {
  intl: IntlShape
}

const TableHeader: React.FC<TableHeaderProps> = ({
  intl: { formatMessage: t }
}) => {
  return (
    <Table.Header>
      <Table.Row>
        <Table.Cell>
          <UppercaseL color="greyMedium">
            {t({ id: 'suppliers.supplier' })}
          </UppercaseL>
        </Table.Cell>
        <Table.Cell>
          <UppercaseL color="greyMedium">
            {t({ id: 'suppliers.id' })}
          </UppercaseL>
        </Table.Cell>
        <Table.Cell>
          <UppercaseL color="greyMedium">
            {t({ id: 'suppliers.email' })}
          </UppercaseL>
        </Table.Cell>
        <Table.Cell>
          <UppercaseL color="greyMedium">
            {t({ id: 'suppliers.sales' })}
          </UppercaseL>
        </Table.Cell>
        <Table.Cell>
          <UppercaseL color="greyMedium">
            {t({ id: 'suppliers.totalRevenue' })}
          </UppercaseL>
        </Table.Cell>
      </Table.Row>
    </Table.Header>
  )
}

export default injectIntl(TableHeader)
